export interface IFaqItem {
  question: string;
  answer: string;
}

export const FAQ_Items: IFaqItem[] = [
  {
    question: "How much does custom software development cost?",
    answer:
      "Project cost depends on scope, complexity, and team size. A focused MVP typically starts around $5,000–$15,000, while full-scale custom platforms range from $20,000 upward. We provide a transparent, fixed-scope estimate after a free discovery call — no surprises.",
  },
  {
    question: "How long does it take to build a mobile app?",
    answer:
      "A core MVP mobile app takes 6–12 weeks from design to launch. Full-featured apps with complex integrations typically run 3–6 months. We work in weekly sprints with daily status updates so you always know exactly where things stand.",
  },
  {
    question: "Do you work with startups or enterprise clients?",
    answer:
      "Both. We regularly work with early-stage founders who need a fast, reliable MVP, and with growing businesses that need to replace legacy systems or scale existing platforms. Our team adapts to your stage and budget.",
  },
  {
    question: "What tech stack does Devkrest use?",
    answer:
      "For mobile we use Flutter and React Native (Expo). For web and backend we use Next.js, React, Node.js, and Laravel. Databases include PostgreSQL, MongoDB, and MySQL. For cloud infrastructure we work across AWS, Google Cloud, and Azure — and we integrate OpenAI and other LLMs for AI-powered features.",
  },
  {
    question: "How does the development process work?",
    answer:
      "We follow a four-step process: Kickoff & Plan (define goals and roadmap), Design with Purpose (UX/UI), Build in Sprints (agile, bi-weekly delivery cycles), and Launch & Scale (deployment, feedback loops, and ongoing improvements). You get daily updates and access to a shared project board throughout.",
  },
  {
    question: "Do you offer post-launch support and maintenance?",
    answer:
      "Yes. We don't disappear after launch. We offer ongoing maintenance, performance monitoring, feature additions, and priority bug fixes. Most clients stay on a monthly retainer to keep their product improving as their business grows.",
  },
];

export const FAQ_Section_Heading = {
  heading: "Frequently Asked Questions",
  sub_heading:
    "Everything you need to know before we start building together.",
};
